import React, {useState, useRef, useEffect } from 'react';
import styles from '../Patient.module.css';
import FilterPatientDetail from '../FilterPatientDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector, useDispatch } from 'react-redux';
import { UserProfilePictureIcon} from '../../../components/icons/Icons';
import EllipsesIcon from '../../../components/icons/EllipsesIcon';
import { faVideo, faPhone, faComments, faUserDoctor, faClipboardCheck, faClipboard } from '@fortawesome/free-solid-svg-icons';
import useAxios from '../../../services/AxiosConfig';
import ChatContainer from '../../../components/ChatContainer';
import { Form, Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { setStaffChatList, setStaffRecipient, setStaffChatVisible, setStaffNewChat, setStaffSelectedIndex } from '../../care-team-message/CareTeamMessageSlicer';
import { setCallInformation, openCallContainer } from '../../../slicers/CallContainerSlice';
import { showAlert } from '../../../components/PerinHealthAlertSlice';
import { setFormField } from '../../../slicers/PatientSlice';
import ProfileIcon from '../../../components/ProfileIcon';

const CareTeamView= () => {

    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const patientInfo = useSelector((state) => state.patient);
    const userAccountId = useSelector((state) => state.userInfo.id);
    const userFullName = useSelector((state) => state.userInfo.fullName);
    const [authModal, setAuthModal] = useState({
        open: false,
        type: "",
        id: 0,
        name: ""
    });

    const onCloseModal = () => {
        setAuthModal({
            open: false,
            type: "",
            id: 0,
            name: ""
        })
    }

    const carePrograms = useSelector((state)=>state.patient.carePrograms);
    const sortedCarePrograms = [...carePrograms].sort((a, b) => {
        return new Date(b.enrollment.startDate) - new Date(a.enrollment.startDate);
    });
    const callContainerShowing = useSelector((state)=>state.callContainer.callContainerShowing);

    const fetchMessages = async (id) => {
        try {
            const responseData = await axios.get(`chime/getAllMessageByUserId?userId=${userAccountId}&recipientType=STAFF`);
            const patientIndex = responseData.data.getAllMessage.findIndex(arr =>
              arr.some(obj => obj.senderId === id || obj.recipientId === id)
            );
            if (patientIndex !== -1) {
              dispatch(setStaffChatList(responseData.data.getAllMessage[patientIndex]));
            } else {
              dispatch(setStaffChatList([]));
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [showStaffChat, setShowStaffChat] = useState(false);
    const [callData, setCallData] = useState({});

    const callStaff = (id, name, audioOnly) => {
        if (callContainerShowing) {
            return;
        }
        const callData = {
            title: `Patient Detail Care Team - ${userFullName} & ${name}`,
            appointmentId: null,
            senderId: userAccountId,
            recipientId: id,
            senderName: userFullName,
            recipientName: name
        };
        dispatch(setCallInformation({"audioOnly":audioOnly, "callData":callData, viewType: "staffMessage"}));
        dispatch(openCallContainer());
    };

    const closeChat = () => {
        dispatch(setStaffChatVisible(false));
        dispatch(setStaffSelectedIndex(-1));
        dispatch(setStaffChatList([]));
        dispatch(setStaffNewChat(false));
        setShowStaffChat(false);
    };

    const chatStaff = (id, name) => {
        if (callContainerShowing) {
            return;
        }
        fetchMessages(id);
        setCallData({
            title: `Patient Detail Care Team - ${userFullName} & ${name}`,
            appointmentId: null,
            senderId: userAccountId,
            recipientId: id,
            senderName: userFullName,
            recipientName: name
        });
        dispatch(setStaffSelectedIndex(0));
        dispatch(setStaffNewChat(false));
        dispatch(setStaffRecipient({ 'id': id, name: name}));
        setShowStaffChat(true);
    };

    const handleChatStartCall = (audioOnly) => {
        closeChat();
        dispatch(setCallInformation({"audioOnly":audioOnly, "callData":callData, viewType: "staffMessage"}));
        dispatch(openCallContainer());
    };

    const careTeam = useSelector((state)=>state.patient.careTeam);
    const searchText = useSelector((state)=>state.patientDetailFilter.searchText);

    const sortedTeam = [...careTeam].filter(item => (
        item.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.title?.toLowerCase().includes(searchText.toLowerCase())
    ));

    const labelColors = {
        "Doctor": "rgba(183, 192, 238, 0.38)",
        "Nurse": "rgba(71, 140, 170, 0.20)",
        "Staff": "rgba(104, 166, 145, 0.22)",
    };

    const buttonRef = useRef(null);
    const containerRef = useRef(null);
    const otherButtons = useRef(null);
    const [selectedRow, setSelectedRow] = useState(false);

    const handleOptionsClick = (id) => {
        if (selectedRow === id) {
            setSelectedRow(null);
        } else {
            setSelectedRow(id);
        }
    };

    const checkProgram = (staff) => {
        const teamIds = staff.groups.map(team => team.teamId);
        let programName = "";
    
        for (const program of sortedCarePrograms) {
            let groups = program.enrollment.groups;
            const hasMatchingTeamId = groups.some(group => teamIds.includes(group.teamId));
    
            if (hasMatchingTeamId) {
                programName = program.name;
                break;
            }
        }
        return programName;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)) {
                    setSelectedRow(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };

    }, []);

    const updateAuthorizationStatus = async () => {
        let status;
        let column;
        switch (authModal.type) {
            case 'pcp':
                status = true;
                column = 'pcp';
                break;
            case 'remove_auth':
                column = 'AlertAuthorize';
                status = false;
                break;
            case 'auth':
                column = 'AlertAuthorize';
                status = true;
                break;
            default:
                status = null;
        }

        if (status === null) {
            dispatch(
                showAlert({
                    header: "Error",
                    message: "Could not update care team member",
                    type: 'danger',
                })
            );
            onCloseModal()
            return;
        }

        let staffId = authModal.id;

        const info = {
            "patientId": patientInfo.id,
            "authStatus": status,
            "column": column
        };
        try {
            const response = await axios.request({
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                url: `careTeam/authorization/${staffId}`,
                data: JSON.stringify(info),
            });
            if (response) {
                dispatch(
                    showAlert({
                        header: "Success",
                        message: `Updated authorizations`,
                        type: 'success'
                    })
                );
                if (Array.isArray(response.data.data)) {
                    dispatch(setFormField({ key: "careTeam", value: response.data.data }));
                    const userMatch = response.data.data.find((item)=> item.id === userAccountId);
                    // update signed in users authorizations
                    if (userMatch) {
                        let userSettingsForPatient = {"pcp": userMatch.pcp, "alertAuthorized": userMatch.alertAuthorized, "sendSMS": userMatch.sendSMS, "alertSilenced":userMatch.alertSilenced}
                        dispatch(setFormField({ key: "userSettingsForPatient", value: userSettingsForPatient }));
                    }
                }
            }

        } catch (error) {
            console.log("error:"+error);
            dispatch(
                showAlert({
                    header: "Error",
                    message: "Could not update care team member",
                    type: 'danger',
                })
            );
        }
        onCloseModal();
    };

    const renderTooltip = (description) => (props) => (
        <Tooltip id={`tooltip-${description}`} {...props}>
            {description}
        </Tooltip>
    );

    return (
        <div className={styles.ViewContainer}>
           {showStaffChat &&
                <Form className={styles.ChatContainer}>
                    <ChatContainer 
                        view="staffMessage"
                        handleClose={closeChat} 
                        onStartVideoCall={() => handleChatStartCall(false)}
                        onStartAudioCall={() => handleChatStartCall(true)}
                    />
                </Form>
           }
           <FilterPatientDetail isSearch={true} isCareTeam={true}/>
            <div className={styles.PatientViewScrollContainer}>
            {sortedTeam.map((staff) => {
                let staffName = `${staff.firstName} ${staff.lastName}`
                    return (
                        <div className={styles.CareTeamListItem} key={staff.id}>
                            <div style={{display:"flex", gap:"20px", alignItems:"center"}}>
                            <ProfileIcon
                                profileUrl={staff.profilePictureURL}
                                firstName={staff.firstName}
                                lastName={staff.lastName}
                                size={35}
                            />
                                <div style={{fontWeight:"500"}}>
                                    {staffName}
                                </div>
                                <div className={styles.BorderedItem}>
                                    {checkProgram(staff)}
                                </div>
                                {staff.title &&
                                    <div className={styles.SpecialtyContainer} style={{backgroundColor:`${labelColors[staff.role.roleCategory]}`}}>
                                        {staff.title}
                                    </div>
                                }
                                <div className={styles.IconContainer} style={staff.title ? {borderLeft: "0.5px solid var(--Neutral-400, #9D9D9E)", paddingLeft:"20px"} : {}}>
                                    {staff.pcp && 
                                        <OverlayTrigger  
                                            placement="top"
                                            delay={{ show: 50, hide: 50 }}
                                            overlay={renderTooltip("Primary Care Physician")}
                                        >
                                             <span style={{ display: 'inline-block' }}>
                                            <FontAwesomeIcon icon={faUserDoctor} />
                                            </span>
                                        </OverlayTrigger>
                                    }
                                    {staff.alertAuthorized && 
                                         <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 50, hide: 50 }}
                                            overlay={renderTooltip("Alert Authorized")}
                                        >
                                            <span style={{ display: 'inline-block' }}>
                                                    <FontAwesomeIcon icon={faClipboardCheck} />
                                                </span>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                            <Tooltip placement="top" show>
                                        Tooltip test
                                    </Tooltip>
                            <div>
                                <button ref={selectedRow === staff.id ? buttonRef : otherButtons} style={{background:"white", border:"none", display:"flex", alignItems:"center"}}onClick={()=>handleOptionsClick(staff.id)}>
                                    <EllipsesIcon />
                                </button>
                                {selectedRow === staff.id &&
                                    <div ref={containerRef} className={styles.CareTeamOptionsContainer}>
                                        {!staff.pcp && staff.role.roleCategory === "Doctor" &&
                                            <div className={styles.careTeamOptions} onClick={()=>setAuthModal({
                                                open: true,
                                                type: "pcp",
                                                id: staff.id,
                                                name: staffName
                                            })}>
                                                <FontAwesomeIcon icon={faUserDoctor} /> {"Assign PCP"}
                                            </div>
                                        }
                                        <div className={styles.careTeamOptions} onClick={()=>setAuthModal({
                                            open: true,
                                            type: staff.alertAuthorized ? "remove_auth" : "auth",
                                            id: staff.id,
                                            name: staffName
                                        })}>
                                            <FontAwesomeIcon icon={staff.alertAuthorized ? faClipboard : faClipboardCheck} /> {staff.alertAuthorized ? "Remove authorization" : "Authorize"}
                                        </div>
                                        <div className={styles.careTeamOptions} onClick={()=>chatStaff(staff.id, staffName)}>
                                            <FontAwesomeIcon icon={faComments} /> Message
                                        </div>
                                        <div className={styles.careTeamOptions} onClick={()=>callStaff(staff.id, staffName, false)}>
                                            <FontAwesomeIcon icon={faVideo} /> Video Call
                                        </div>
                                        <div className={styles.careTeamOptions} onClick={()=>callStaff(staff.id, staffName, true)}>
                                            <FontAwesomeIcon icon={faPhone} />Phone Call
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                })
                }
            </div>
            <Modal
                show={authModal.open}
                onHide={onCloseModal}
                centered
            >
                <Modal.Header closeButton>
                    <div className="subtitle-1">
                        {authModal.type === "pcp" ? `Assign ${authModal.name} as Primary Care Physician?` : authModal.type === "remove_auth" ? `Remove alert authorizations for ${authModal.name}?` :   `Authorize ${authModal.name}?`}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="body-2">
                        {authModal.type === "pcp" && 
                           (patientInfo.pcp.accountId !== 0 ? `This will remove ${patientInfo.pcp.fullName} as ${patientInfo.fullName}'s primary care physician.` :
                            `This will assign ${authModal.name} as ${patientInfo.fullName}'s primary care physician.`
                           )
                        }
                        {authModal.type === "auth" && 
                           `This will allow ${authModal.name} to manage alerts.`
                        }
                        {authModal.type === "remove_auth" && 
                           `This will remove ${authModal.name}'s authorization to manage alerts.`
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className={styles.ModelButton} onClick={() => updateAuthorizationStatus()}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CareTeamView;